// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_3smSpA","clearfix":"_3plvZS","tab":"_3KCmhW","hover":"GKdk6Y","active":"_1-AKXD","swipable":"_3xWJ3t"};